import { useSearchParams } from "react-router-dom";
import { useAuth } from "@/core/auth/hooks/useAuth";
import { useCurrentBusiness } from "@/features/business/hooks/useCurrentBusiness";
import { Button } from "@/shared/components/shadcn/Button";
import { Card } from "@/shared/components/ui/Card";
import { Page, PageContent } from "@/shared/components/ui/Page";
import { PageHeader } from "@/shared/components/ui/PageHeader";
import { useAppNavigation } from "@/shared/hooks/useAppNavigation";
import { FormsList } from "../components/FormsList";

export function FormsListPage() {
  const { businessId } = useCurrentBusiness();
  const { user } = useAuth();
  const { goToFormDetails } = useAppNavigation();
  const [params, setParams] = useSearchParams();
  return (
    <Page>
      <PageHeader title="Forms" />
      <PageContent>
        <div className="space-y-6">
          <Card tone="matcha" className="space-y-3">
            <h2 className="text-lg font-bold">Editing available online only</h2>
            <p className="text-sm">Create and edit your forms on the Froppio Forms website. Preview them and attach them to services here.</p>
            <Button asChild><a href="https://forms.fropp.io" target="_blank" rel="noopener noreferrer">Open Forms website<span className="sr-only"> in your browser</span></a></Button>
          </Card>
          <FormsList key={`${user?.id}:${businessId}`} onPreview={(form) => goToFormDetails(form.id)}
            search={params.get("search") ?? ""} onSearchChange={(search) => setParams((current) => {
              const next = new URLSearchParams(current);
              if (search) next.set("search", search);
              else next.delete("search");
              return next;
            }, { replace: true })} />
        </div>
      </PageContent>
    </Page>
  );
}
